import React from "react";

const TextComposition = () => {
  return (
    <React.Fragment>
      <h3 className="heading-tertiary mb-sm">
        you are going to fall in love with nature
      </h3>
      <p className="paragraph">
        Lorem ipsum, dolor sit amet consectetur adipisicing elit. Architecto
        tenetur perspiciatis debitis excepturi? Ipsam doloremque quas a harum at
        accusantium fuga officia, quia assumenda suscipit dolor fugit facilis!
        Laboriosam, quam.
      </p>
      <h3 className="heading-tertiary mb-sm">Live adventures with nature</h3>
      <p className="paragraph">
        Lorem ipsum dolor sit amet, consectetur adipisicing elit. Porro alias
        reprehenderit ipsa molestias dolor quisquam ut.
      </p>
      <a href="#" className="btn-text">
        Learn more &rarr;
      </a>
    </React.Fragment>
  );
};

export default TextComposition;
